import script from "./DevTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./DevTeam.vue?vue&type=script&setup=true&lang=js"

import "./DevTeam.vue?vue&type=style&index=0&id=0dd7958a&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd7958a"]])

export default __exports__